class LoadingController {

    constructor($window, $state, $location, auth0Service, configService, authStorageService) {
        this.$window = $window;
        this.$state = $state;
        this.$location = $location;
        this.auth0Service = auth0Service;
        this.configService = configService;
        this.authStorageService = authStorageService;
    }

    $onInit () {
        this.redirectUrl = this.configService.get('appUrl');

        return this.auth0Service.parseHash({ hash: this.$location.hash() })
            .then(result => {
                if (!result || !result.accessToken) {
                    this.$window.location = this.redirectUrl;
                    return;
                }

                this.authStorageService.setAccessToken(result.accessToken);

                let role = result.idTokenPayload['https://www.lobby.travel/role'];

                result.idTokenPayload.role = role;

                this.authStorageService.setProfile(result.idTokenPayload);

                return this.$state.go('app.dashboard');
            })
            .catch(error => {
                this.error = error.error;
                this.errorDescription = error.errorDescription;
            });
    }
}

LoadingController.$inject = ['$window', '$state', '$location', 'auth0Service', 'configService', 'authStorageService'];

export default LoadingController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/controllers/loading.controller.js